import { render, staticRenderFns } from "./DuplicateFromCasinoReview.vue?vue&type=template&id=1e9c2112&"
import script from "./DuplicateFromCasinoReview.vue?vue&type=script&lang=js&"
export * from "./DuplicateFromCasinoReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports